import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { ISuccessMessage } from '@curbnturf/entities';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'user';

/** Which ledger an adjustment applies to: host earnings ("account balance") or CurbNTurf Cash. */
export type LedgerKind = 'account' | 'cash';

/**
 * Manual ledger adjustments (admin-only on the server). Moved from the app's
 * services/user-cash.service.ts:
 *   account: add = POST /user/:id/mark,      payout = POST /user/:id/mark-payout
 *   cash:    add = POST /user/:id/mark-cash, payout = POST /user/:id/mark-cash-payout
 */
@Injectable({ providedIn: 'root' })
export class AdminCashApiService {
  private readonly http = inject(HttpClient);

  /** A manual adjustment: a negative amount is a deduction. */
  add(
    kind: LedgerKind,
    userId: number,
    amount: number,
    note: string,
    privateNote?: string,
  ): Observable<ISuccessMessage> {
    return this.post(kind === 'account' ? 'mark' : 'mark-cash', userId, amount, note, privateNote);
  }

  /** Records money sent; CNT Cash payouts also get a separate withdrawal-fee row on the server. */
  markPayout(
    kind: LedgerKind,
    userId: number,
    amount: number,
    note: string,
    privateNote?: string,
  ): Observable<ISuccessMessage> {
    return this.post(kind === 'account' ? 'mark-payout' : 'mark-cash-payout', userId, amount, note, privateNote);
  }

  private post(
    path: string,
    userId: number,
    amount: number,
    note: string,
    privateNote?: string,
  ): Observable<ISuccessMessage> {
    return this.http.post<ISuccessMessage>(`${API_URL}/${userId}/${path}`, { userId, amount, note, privateNote });
  }
}
